/* Syrup Oracle: "Stock the bar" — add a recipe's BG Reynolds bottles to the
   cart without leaving the recipe page.
   Reads the highlighted syrup ingredients from the rendered recipe card
   (.so-recipe .syrup — the card marks BG Reynolds lines), matches them to
   products via /products.json (same conservative core/alias matching as the
   product linkifier), and renders per-bottle Add buttons plus an add-all.
   Progressive enhancement: no matches or fetch failure -> strip never shows. */
(function () {
  'use strict';
  var mount = document.getElementById('so-recipe-cart');
  if (!mount) return;

  var GENERIC = ['cocktail', 'syrup', 'syrups', 'tropical', 'original', 'mix', 'mixer', 'bg', 'reynolds', 'the', '(pre-sale)', 'pre-sale'];
  var ALIASES = { 'red-fassionola': ['fassionola'], 'divine-vanilla': ['vanilla'], 'wild-ginger': ['ginger'] };

  function coreOf(title) {
    return title.split(/\s+/).filter(function (w) {
      return GENERIC.indexOf(w.toLowerCase().replace(/[^a-z\-()']/g, '')) === -1 && w.trim() !== '';
    }).join(' ').trim().toLowerCase();
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // The card's BG ingredient names, e.g. "BG Reynolds Orgeat"
  var wanted = [];
  document.querySelectorAll('.so-recipe .syrup').forEach(function (el) {
    var t = el.textContent.replace(/^BG Reynolds\s*/i, '').trim().toLowerCase();
    if (t && wanted.indexOf(t) === -1) wanted.push(t);
  });
  if (!wanted.length) return;

  fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (data) {
    var products = data.products || [];
    var rows = [];
    wanted.forEach(function (name) {
      var hit = null;
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var core = coreOf(p.title);
        var aliases = (ALIASES[p.handle] || []).concat(core ? [core] : []);
        var matched = aliases.some(function (a) {
          return a && (name === a || name.indexOf(a) !== -1 || a.indexOf(name) !== -1);
        });
        if (matched) { hit = p; break; }
      }
      if (!hit) return;
      var v = null;
      for (var j = 0; j < hit.variants.length; j++) {
        if (hit.variants[j].available) { v = hit.variants[j]; break; }
      }
      if (rows.some(function (r2) { return r2.handle === hit.handle; })) return;
      rows.push({
        handle: hit.handle,
        title: hit.title.replace(/ Tropical Cocktail Syrup| Cocktail Syrup| Cocktail Mix/g, ''),
        variantId: v ? v.id : null,
        price: v ? Math.round(parseFloat(v.price) * 100) : null,
        size: v && v.title !== 'Default Title' ? v.title : ''
      });
    });
    if (!rows.length) return;

    var lis = rows.map(function (r2) {
      var right = r2.variantId
        ? '<span class="so-rcart__price">' + money(r2.price) + '</span><button type="button" class="so-rcart__add" data-variant="' + r2.variantId + '">Add</button>'
        : '<span class="so-rcart__rest">resting between batches</span>';
      return '<li class="so-rcart__row"><a class="so-rcart__name" href="/products/' + r2.handle + '">' + esc(r2.title) + (r2.size ? ' <span class="so-rcart__size">' + esc(r2.size) + '</span>' : '') + '</a>' + right + '</li>';
    }).join('');
    var anyAvailable = rows.some(function (r2) { return r2.variantId; });

    mount.innerHTML =
      '<div class="so-rule so-rcart__rule"><span>Stock the bar</span></div>' +
      '<p class="so-rcart__lede">The BG Reynolds bottles this drink calls for:</p>' +
      '<ul class="so-rcart__list">' + lis + '</ul>' +
      (anyAvailable ? '<button type="button" class="btn so-rcart__all" id="soRcartAll">Add all the bottles</button>' : '') +
      '<p class="so-rcart__status" id="soRcartStatus" aria-live="polite"></p>';
    mount.hidden = false;

    var statusEl = document.getElementById('soRcartStatus');
    function add(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }
    mount.querySelectorAll('.so-rcart__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true; btn.textContent = '…';
        add([{ id: +btn.getAttribute('data-variant'), quantity: 1 }]).then(function () {
          btn.textContent = 'In the cart ✓';
          statusEl.innerHTML = 'Added. <a href="/cart">Review the cart &rarr;</a>';
        }).catch(function () { btn.disabled = false; btn.textContent = 'Add'; statusEl.textContent = 'The cart balked — try once more.'; });
      });
    });
    var allBtn = document.getElementById('soRcartAll');
    if (allBtn) allBtn.addEventListener('click', function () {
      allBtn.disabled = true; allBtn.textContent = 'Carrying the bottles…';
      var items = rows.filter(function (r2) { return r2.variantId; }).map(function (r2) { return { id: r2.variantId, quantity: 1 }; });
      add(items).then(function () {
        window.location.href = '/cart';
      }).catch(function () { allBtn.disabled = false; allBtn.textContent = 'Add all the bottles'; statusEl.textContent = 'The cart balked — try once more.'; });
    });
  }).catch(function () { /* progressive enhancement only */ });
})();
